export default __webpack_public_path__ + "static/media/group-option-glasses-unselected.2c7a8855.svg";